import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { createImperativePromise } from 'awesome-imperative-promise';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import useFetch from './useFetch';

const updateDebounced = AwesomeDebouncePromise((fetch, accountId, domainId, id, payload) => {
  return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/generatedContent/${id}`, {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
}, 300);

let promiseCancel;

const useAiContentData = () => {
  const [generatedContent, setGeneratedContent] = useState();
  const [error, setError] = useState();
  const { accountId, domainId } = useParams();

  const lastSavedContent = useRef();

  const customFetch = useFetch();
  const fetchUrl = `/api/admin/accounts/${accountId}/domains/${domainId}/generatedContent/chatBot`;
  const createUrl = `/api/admin/accounts/${accountId}/domains/${domainId}/generatedContent`;

  useEffect(() => {
    customFetch(fetchUrl, {
      method: 'POST',
      body: JSON.stringify({}),
    })
      .then(({ generatedContent }) => {
        setGeneratedContent(generatedContent);
        const data = generatedContent?.data;
        lastSavedContent.current = data;
      })
      .catch(setError);
  }, [fetchUrl, customFetch]);

  const createContent = () => {
    setError(null);
    setGeneratedContent(undefined);
    customFetch(createUrl, {
      method: 'POST',
      body: JSON.stringify({
        type: null,
        marketingChannel: 'chatBot',
        name: `chatBot_${new Date().toISOString()}`,
        parentId: null,
        model: 'sol',
      }),
    })
      .then(({ generatedContent }) => setGeneratedContent(generatedContent))
      .catch(setError);
  };

  const handleChange = (event) => {
    if (promiseCancel) {
      promiseCancel();
    }
    let updatedContent;

    const { name, value } = event.target;

    if (value) updatedContent = JSON.parse(JSON.stringify({ ...generatedContent, [name]: value }));
    setGeneratedContent(updatedContent);

    const { cancel } = createImperativePromise(
      updateDebounced(fetch, accountId, domainId, generatedContent.id, updatedContent)
    );
    promiseCancel = cancel;
  };

  return { data: generatedContent, handleChange, error, createContent };
};

export default useAiContentData;
